import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, AxisAlignedDimensionsIcon } from '@frontend/components';

import { dimensionTool } from 'modules/common/viewer/cadViewer/data/actions';
import { getIsDimensionToolActive } from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const DimensionTool = ({ isEnabled }) => {
  const isActive = useSelector(getIsDimensionToolActive);
  const dispatch = useDispatch();
  const toggleDimensionTool = useCallback(() => {
    dispatch(dimensionTool.toggle());
  }, [dispatch]);

  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Axis Aligned Dimensions"
          secondLine="All visible bodies"
        />
      }
    >
      <ViewerButton isActive={isActive} onClick={toggleDimensionTool}>
        <AxisAlignedDimensionsIcon boxSize={2.5} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default DimensionTool;
